/* eslint-disable no-useless-escape */
import $ from 'jquery';

/* global x5script */

class Sections {
  constructor() {
    this.sections = $('.js-sections');
    this.isHomePageSections = x5script.isHomePageSections;
    this.isSectionsPage = x5script.isSectionsPage;
    this.homePageUrl = x5script.homePageUrl;
    this.header = $('.js-header');

    if (!this.sections.length) {
      return;
    }

    this.section = this.sections.find('.js-section').not('.is-hidden');

    if (!this.section.length) {
      return;
    }

    if (this.section.length === 1) {
      this.header.show();
    }

    this.scrolling = false;
    this.timeout = true;
    this.isClick = false;
    this.activeGroupId = 'none';

    this.headerDebounce = null;
    this.isHeaderHidden = true;

    this.isFirefox = /Firefox/i.test(navigator.userAgent);
    this.isIe =
      /MSIE/i.test(navigator.userAgent) ||
      /Trident.*rv\:11\./i.test(navigator.userAgent);
    this.scrollSensitivitySetting = 30; // Increase/decrease this number to change sensitivity to trackpad gestures (up = less sensitive; down = more sensitive)
    this.slideDuration = 1200; // Amount of time for which slide is "locked"
    this.currentSlideNumber = 0;
    this.getSlidesNumber();

    this.innerSections();
    this.navControl();
    this.hashControl();
    // this.popStateControl();
    this.setContentItems();

    this.scrollSections();
    this.headerVisibility();

    if (!window.location.hash) {
      this.setButtonsWidth();
    }
  }

  headerShow() {
    this.header
      .css({
        opacity: 0,
        display: 'block',
      })
      .stop()
      .animate({ opacity: 1 }, 500);
  }

  headerHide() {
    this.header.stop().animate({ opacity: 0 }, 500, () => this.header.hide());
  }

  headerVisibility() {
    this.header.on('mousemove mouseover', () => {
      clearInterval(this.headerDebounce);
      this.isHeaderHidden = false;
    });

    $(document).on('mousemove', () => {
      if ($(window).width() < 1025) {
        if (this.isHeaderHidden) {
          this.header.css({
            opacity: 1,
            display: 'block',
          });
          this.isHeaderHidden = false;
        }
        return;
      }

      if (this.isHeaderHidden) {
        this.headerShow();
        this.isHeaderHidden = false;
      }
      clearInterval(this.headerDebounce);

      this.headerDebounce = setInterval(() => {
        if (!this.isHeaderHidden) {
          this.headerHide();
          this.isHeaderHidden = true;
        }
      }, 1000);
    });
  }

  getSlidesNumber() {
    this.section = this.sections.find('.js-section').not('.is-hidden');
    this.totalSlideNumber = this.section.length;
    // reset mousmove for new sections
    // this.headerVisibility();
  }

  setButtonsWidth() {
    this.section.each((i, el) => {
      const section = $(el);
      const buttons = section.find('.js-btn-fws');

      if (buttons.length > 1) {
        const buttonsWidths = buttons
          .map((index, elem) => $(elem).outerWidth())
          .get();

        const maxWidth = Math.max(...buttonsWidths);
        buttons.css({ 'max-width': maxWidth, width: maxWidth });
      }
    });
  }

  innerSections() {
    this.button = $('.js-btn-fws');

    this.button.on('click', e => {
      e.preventDefault();
      const self = $(e.currentTarget);
      self.addClass('no-focus');
      this.activeGroup = self.attr('href');
      this.activeGroupId = this.activeGroup.slice(1);

      this.activeGroupSections = this.sections.find(
        `.js-section[data-inner-id="${this.activeGroupId}"]`,
      );

      if (this.activeGroupSections.length) {
        this.activeGroupSections
          .removeClass('is-hidden')
          .addClass('is-next is-hash-scrolling');
        this.activeGroupSections.find('.js-section-bg').css({ opacity: 1 });
        this.getSlidesNumber();
        this.scrollEvents();
        this.touchEvents();
        this.goDown();
      }
    });
  }

  navControl() {
    this.navLink = $('.js-main-nav-link');

    if (this.navLink.length) {
      this.navLink.on('click', e => {
        const link = $(e.currentTarget);
        this.hash = link.attr('href');

        if (this.scrolling) {
          return;
        }

        if (this.isSectionsPage && this.hash.slice(0, 1) === '#') {
          e.preventDefault();

          if (this.isHomePageSections) {
            this.isClick = true;
            this.scrollToSectionViaHash();
          } else if (this.isSectionsPage && !this.isHomePageSections) {
            // window.location = `${this.homePageUrl}/${this.hash}`;
          }
        }
      });
    }
  }

  hashControl() {
    if (this.isHomePageSections && window.location.hash.length > 1) {
      this.hash = window.location.hash;
      this.scrollToSectionViaHash();
    }
  }

  popStateControl() {
    window.onpopstate = e => {
      if (this.scrolling) {
        e.preventDefault();
      }
      if (e.state !== null && 'section' in e.state) {
        const state = e.state.section;

        this.hash = `#${state}`;
        this.scrollToSectionViaHash();
      }
    };
  }

  scrollToSectionViaHash() {
    this.sections.addClass('is-hash-scrolling');
    const section = this.sections.find(`${this.hash}`);
    const sectionHiddenElems = section.prevAll('.is-hidden').length;
    const activeSection = this.sections.find('.is-active');
    const activeSectionHiddenElems = activeSection.prevAll('.is-hidden').length;
    const activeSectionIndex = activeSection.index() - activeSectionHiddenElems;

    if (section.length) {
      const sectionIndex = section.index() - sectionHiddenElems;

      if (this.isClick && activeSectionIndex === sectionIndex) {
        return;
      }

      this.section.removeClass(
        'is-up-scroll is-down-scroll is-next is-prev is-anim is-anim-up is-anim-down',
      );
      section.addClass('is-active');

      if (activeSectionIndex !== sectionIndex) {
        this.scrolling = true;

        section
          .addClass('is-active is-anim-down')
          .prevAll()
          .not('.is-hidden')
          .addClass('is-down-scroll is-prev');

        section
          .nextAll()
          .not('.is-hidden')
          .addClass('is-next');

        section
          .prevAll()
          .not('.is-active')
          .hide();
        section
          .nextAll()
          .not('.is-active')
          .hide();

        activeSection.show();

        this.currentSlideNumber = sectionIndex;
      }

      this.slideDurationTimeout();
    }
  }

  setContentItems() {
    this.section.each((i, el) => {
      const items = $(el).find('.js-section-content-item');

      if (items.length) {
        items.each((index, item) => {
          const delay = index * 0.1;
          $(item).css({ 'transition-delay': `${delay}s` });
        });
      }
    });
  }

  scrollEvents() {
    let events = 'scroll wheel DOMMouseScroll mousewheel';

    if (this.isIe) {
      events = 'scroll wheel DOMMouseScroll';
    } else if (this.isFirefox) {
      events = 'scroll mousewheel DOMMouseScroll';
    }

    this.section.off(events);
    this.section.on(events, e => {
      e.preventDefault();
      let delta;

      if (this.scrolling) {
        return;
      }

      if ($(e.target).closest('.js-google-map-js').length) {
        return;
      }

      if (this.isFirefox) {
        delta = e.originalEvent.detail * -120;
      } else if (this.isIe) {
        delta = -e.originalEvent.deltaY;
      } else {
        delta = e.originalEvent.wheelDelta;
      }

      if (delta !== 0) {
        if (delta > 0 && delta >= this.scrollSensitivitySetting) {
          this.scrollSectionsHandler('up');
        } else if (delta <= -this.scrollSensitivitySetting) {
          this.scrollSectionsHandler('down');
        }
      }
    });
  }

  touchEvents() {
    this.section.on('touchstart touchemove', e => {
      this.startPos = e.pageY || e.originalEvent.changedTouches[0].pageY;
    });

    this.section.on('touchend', e => {
      if ($(e.target).closest('.js-google-map-js').length) {
        return;
      }

      this.endPos = e.pageY || e.originalEvent.changedTouches[0].pageY;

      if (this.startPos > this.endPos) {
        this.scrollSectionsHandler('down');
      } else if (this.startPos < this.endPos) {
        this.scrollSectionsHandler('up');
      }
    });
  }

  scrollSections() {
    this.touchEvents();
    this.scrollEvents();
  }

  goDown() {
    if (this.currentSlideNumber !== this.totalSlideNumber - 1) {
      this.currentSlideNumber += 1;
      this.nextSection();
      this.slideDurationTimeout();

      this.section
        .removeClass('is-active is-anim is-anim-up is-anim-down')
        .eq(this.currentSlideNumber)
        .removeClass('is-next is-prev')
        .addClass(`is-active is-anim-${this.dir}`);

      if (this.currentSlideNumber + 1 <= this.totalSlideNumber) {
        this.section
          .not('.is-hidden')
          .eq(this.currentSlideNumber + 1)
          .removeClass('is-prev')
          .addClass('is-next');
      }
      if (this.currentSlideNumber - 1 >= 0) {
        this.section
          .not('.is-hidden')
          .eq(this.currentSlideNumber - 1)
          .removeClass('is-next')
          .addClass('is-prev');
      }
    } else {
      this.scrolling = false;
    }
  }

  goUp() {
    if (this.currentSlideNumber !== 0) {
      this.currentSlideNumber -= 1;
      this.previousSection();
      this.slideDurationTimeout();

      this.section
        .removeClass('is-active is-anim is-anim-up is-anim-down')
        .eq(this.currentSlideNumber)
        .removeClass('is-next is-prev')
        .addClass(`is-active is-anim-${this.dir}`);

      if (this.currentSlideNumber - 1 >= 0) {
        this.section
          .not('.is-hidden')
          .eq(this.currentSlideNumber - 1)
          .removeClass('is-next')
          .addClass('is-prev');
      }
      if (this.currentSlideNumber + 1 <= this.totalSlideNumber) {
        this.section
          .not('.is-hidden')
          .eq(this.currentSlideNumber + 1)
          .removeClass('is-prev')
          .addClass('is-next');
      }
    } else {
      this.scrolling = false;
    }
  }

  scrollSectionsHandler(direction) {
    this.dir = direction;

    if (!this.scrolling) {
      this.scrolling = true;

      if (this.dir === 'down') {
        this.goDown();
      }
      if (this.dir === 'up') {
        this.goUp();
      }
    }
  }

  slideDurationTimeout() {
    setTimeout(() => {
      this.section
        .not('.is-hidden')
        .show()
        .eq(this.currentSlideNumber)
        .addClass(`is-anim is-active`);
    }, 1000);

    setTimeout(() => {
      const newSection = this.section
        .eq(this.currentSlideNumber)
        .not('.is-hidden');
      const newSectionInnerId = newSection.data('inner-id') || 'none';
      this.section.removeClass('is-active');
      newSection.addClass('is-active');
      this.scrolling = false;
      this.sections.removeClass('is-hash-scrolling');

      // Hide inner sections if needed
      if (
        this.activeGroupId !== 'none' &&
        newSectionInnerId !== this.activeGroupId
      ) {
        const indexOffset =
          this.dir === 'up' ? 0 : this.activeGroupSections.length;
        this.activeGroupSections
          .addClass('is-hidden')
          .removeClass('is-prev is-next is-hash-scrolling');
        this.activeGroupSections.find('.js-section-bg').css({ opacity: 0 });
        this.getSlidesNumber();
        this.activeGroupId = 'none';
        this.currentSlideNumber = this.currentSlideNumber - indexOffset;
      }

      if (window.location.hash) {
        this.setButtonsWidth();
        window.history.replaceState(null, null, ' ');
      }
    }, this.slideDuration);
  }

  nextSection() {
    this.slide = this.section.eq(this.currentSlideNumber - 1).not('.is-hidden');
    this.slide.removeClass('is-up-scroll').addClass('is-down-scroll');
  }

  previousSection() {
    this.slide = this.section.eq(this.currentSlideNumber).not('.is-hidden');
    this.slide.removeClass('is-down-scroll').addClass('is-up-scroll');
  }
}

export default new Sections();



// WEBPACK FOOTER //
// ./src/scripts/modules/sections.js